import React from "react";
import { IconX } from "@tabler/icons";
import { TableInstance } from "react-table";
import { Button } from "../../Button";

export type ColumnFilterListProps<T extends object> = TableInstance<T>;

export const ColumnFilterList = <T extends object>(
  props: ColumnFilterListProps<T>
): JSX.Element => {
  const {
    state: { filters },
    columns,
    setFilter,
  } = props;

  return filters.length > 0 ? (
    <div className="btn-list">
      {filters.map((x) => (
        <Button
          key={x.id}
          small
          outline
          onClick={() => setFilter(x.id, "")}
          color="info"
        >
          <IconX />
          {`${columns.filter((col) => col.id === x.id)[0].Header}: ${x.value}`}
        </Button>
      ))}
    </div>
  ) : (
    <></>
  );
};

export default ColumnFilterList;
